import { render } from "./AppAvatar.vue?vue&type=template&id=6409df54&scoped=true"
import script from "./AppAvatar.vue?vue&type=script&lang=js"
export * from "./AppAvatar.vue?vue&type=script&lang=js"

import "./AppAvatar.vue?vue&type=style&index=0&id=6409df54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6409df54"]])

export default __exports__